import './_quick-shop.scss';
import component from './quick-shop';

export default component;
